module.exports = __webpack_public_path__ + "img/pb6.eafef511.png";